const GUTTER = "scrollbar-gutter";

let activeLocks = 0;
let restoreScrollTop = 0;
let restoreOverflow = "";
let restoreGutter = "";
let restorePaddingRight = "";

const appRoot = () => document.getElementById("root");

/**
 * Stops the document behind a full-viewport dialog from scrolling.
 * Reference counted so nested dialogs release it only once the last one closes.
 *
 * The document also gives up its reserved scrollbar gutter while locked, since
 * nothing can be painted there once it cannot scroll, and that width goes to the
 * dialog instead of sitting empty. The page behind is padded by the same amount
 * so it does not reflow into the freed space while the dialog is still sliding
 * in. Scrollbars themselves keep whatever width the browser and guest chose.
 */
export const lockDocumentScroll = (): void => {
    const element = document.documentElement;

    if (activeLocks === 0) {
        const root = appRoot();
        // Measured rather than assumed: gutter width follows browser and OS.
        const gutterWidth = window.innerWidth - element.clientWidth;

        restoreScrollTop = element.scrollTop;
        restoreOverflow = element.style.overflow;
        restoreGutter = element.style.getPropertyValue(GUTTER);
        restorePaddingRight = root?.style.paddingRight ?? "";

        element.style.overflow = "hidden";
        element.style.setProperty(GUTTER, "auto");

        // The dialog is portalled outside #root, so this holds the page behind
        // still without narrowing the dialog itself.
        if (root && gutterWidth > 0) {
            root.style.paddingRight = `${gutterWidth}px`;
        }
    }

    activeLocks += 1;
};

export const releaseDocumentScroll = (): void => {
    if (activeLocks === 0) return;

    activeLocks -= 1;
    if (activeLocks > 0) return;

    const element = document.documentElement;
    const root = appRoot();

    element.style.overflow = restoreOverflow;

    if (restoreGutter) {
        element.style.setProperty(GUTTER, restoreGutter);
    } else {
        element.style.removeProperty(GUTTER);
    }

    if (root) {
        root.style.paddingRight = restorePaddingRight;
    }

    element.scrollTop = restoreScrollTop;
};

/** Test seam. */
export const getActiveDocumentScrollLocks = (): number => activeLocks;
